import React from "react";
import { FormControl, ControlLabel, Button } from "react-bootstrap";
import immutable from 'immutable';
import moment from 'moment';

export default class HistoryTCSearchForm extends React.Component {
    constructor(props) {
        super(props);
        this.state = props.vm;
        this.inputs = {};

        this.getDateList = this.getDateList.bind(this);
        this.onSearch = this.onSearch.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        let newState = immutable.fromJS(nextProps.vm).toJS();

        if (newState.timecardStatusList.length > 0) {
            newState.selectedMonth = moment().format("MM/YYYY");

            if (newState.selectedStatus == null || newState.selectedStatus.trim() == "")
                newState.selectedStatus = newState.timecardStatusList[0].statusCode;
        }
        this.setState(newState);

    }

    getDateList() {
        const result = [];
        let month = moment();
        result.push({ value: month.format("MM/YYYY"), text: `${month.format("MM/YYYY")} - Current Month & Future` });
        if (['Submitted', 'Approved', 'VerifiedByAdmin'].includes(this.state.selectedStatus)) {
            month.add(1, "month");
            result.splice(0, 0, { value: month.format("MM/YYYY"), text: `${month.format("MM/YYYY")} - Next Month` });
            month.subtract(2, "month");
            result.push({ value: month.format("MM/YYYY"), text: `${month.format("MM/YYYY")} - Previous Month` });
        } else {
            for (let i = 0; i < 11; i++) {
                month.subtract(1, "month");
                result.push({ value: month.format("MM/YYYY"), text: `${month.format("MM/YYYY")}` });
            }
        }

        return result;
    }

    onSearch() {
        if (this.props.onSearch) this.props.onSearch({
            timecardStatus: this.inputs.timecardStatus.value,
            monthEnding: this.inputs.monthEnding.value,
            employeeName: this.inputs.employeeName.value,
            company: this.inputs.company.value,
            office: this.inputs.office.value
        });
    }

    render() {
        const self = this;
        let hiddenFilters = self.props.hideFilters? self.props.hideFilters.split(','): [];

        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-6 ap-hidden">
                        <ControlLabel>Please select</ControlLabel>
                        <FormControl componentClass="select" inputRef={node => self.inputs.timecardStatus = node}
                            onChange={evt => self.onSearch()}
                            defaultValue={self.state.selectedStatus}>
                            {self.state.timecardStatusList.map(s => <option key={s.statusCode} value={s.statusCode}>{s.description}</option>)}
                        </FormControl>
                    </div>
                    <div className="col-md-6">
                        <ControlLabel>For month ending</ControlLabel>
                        <FormControl componentClass="select" inputRef={node => self.inputs.monthEnding = node}
                            defaultValue={self.state.selectedMonth}>
                            {this.getDateList().map(d => {
                                return <option key={d.value} value={d.value}>{d.text}</option>;
                            })}
                        </FormControl>
                    </div>
                    <div className={hiddenFilters.includes("people")? "ap-hidden": "col-md-6"}>
                        <ControlLabel>Employee Name (Last, First)</ControlLabel>
                        <FormControl inputRef={node => self.inputs.employeeName = node} list="peopleDataList" />
                    </div>
                    <div className={hiddenFilters.includes("company")? "ap-hidden": "col-md-3"}>
                        <ControlLabel>Company</ControlLabel>
                        <FormControl componentClass="select" inputRef={node => self.inputs.company = node}>
                            <option value="">-- Select a company --</option>
                            {self.state.companies.map(c => <option key={c} value={c}>{c}</option>)}
                        </FormControl>
                    </div>
                    <div className={hiddenFilters.includes("office")? "ap-hidden": "col-md-3"}>
                        <ControlLabel>Office</ControlLabel>
                        <FormControl inputRef={node => self.inputs.office = node} />
                    </div>
                </div>
                <div className="row ap-top-margined">
                    <div className="col-md-12">
                        <Button className="btn-info ap-fullsize" onClick={this.onSearch}>SEARCH</Button>
                    </div>
                </div>
            </div>
        );
    }
}